'use client';

import { useQueryStates } from 'nuqs';
import { useTransition } from 'react';

import { searchParamsItems } from '@/app/used-cars/_components/search/search-results/search-params';

export function useClearAllFilters() {
  const [, startTransition] = useTransition();

  const [, setQueryStates] = useQueryStates(searchParamsItems, {
    shallow: false,
    startTransition,
  });

  const clearAll = () => {
    const toClear: Record<string, null> = {};

    Object.keys(searchParamsItems).forEach((key) => {
      if (key !== 'type') {
        toClear[key] = null;
      }
    });

    setQueryStates(toClear);
  };

  return { clearAll };
}
